// src/components/SimpleFormComponents/SimpleEntityForm.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Col, Divider, Row } from 'antd';
import SimpleEntityPersonFormBR from './br/SimpleEntityPersonFormBR';
import SimpleDataOriginForm from './SimpleDataOriginForm';
import appService from 'services/appService';
import SimpleAddressForm from 'components/SimpleComponents/SimpleEntityForm/SimpleAddressForm';
import SimpleEntityCompanyFormBR from 'components/SimpleComponents/SimpleEntityForm/br/SimpleEntityCompanyFormBR';
import SimpleInput from 'components/SimpleComponents/SimpleInput';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const SimpleEntityForm = ({
  showAddressForm = true,
  entityType,
  entityTypeModel, // 'company' | 'person' | 'manual' (hybrid mode)
  locale = appService.getLocale(),
  subdocumentField,
  hideFormCountrySelector,
  showNote=true,
  setState, // from parent to update entityType state
  state, // current state from parent
  subscriptionCountryCode, // country from subscription (priority over locale)
  userCountryCode, // country from logged-in user (priority after subscription)
  ...props
}) => {
  // ---------------------------------------------------------------------------
  // PROPS, CONTEXTS & GLOBAL STATE
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // HOOKS & REFS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // LOCAL VARIABLES I
  // ---------------------------------------------------------------------------
  // Get countryCode from state (managed by SimpleDataOriginForm)
  const countryCode = state?.countryCode || locale?.toUpperCase() || 'BR';

  // Current effective entity type (from state or prop)
  const effectiveEntityType = state?.entityType || entityType || 'company';

  // ---------------------------------------------------------------------------
  // LOCAL STATE
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // EFFECTS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // HANDLERS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // LOCAL VARIABLES II
  // ---------------------------------------------------------------------------
  const isBROrPT = countryCode === 'BR' || countryCode === 'PT';

  // ---------------------------------------------------------------------------
  // UI
  // ---------------------------------------------------------------------------
  return (
    <div>
      <SimpleDataOriginForm
        {...props}
        subdocumentField={subdocumentField}
        setState={setState}
        state={state}
        entityTypeModel={entityTypeModel}
        entityType={effectiveEntityType}
        hideFormCountrySelector={hideFormCountrySelector}
        locale={locale}
        subscriptionCountryCode={subscriptionCountryCode}
        userCountryCode={userCountryCode}
        isEntityProfile
      />

      {/* ENTITY TYPE FORMS */}
      {effectiveEntityType === 'person' ? (
        // Person mode (CPF/NIF/SSN) - dynamic by country
        <SimpleEntityPersonFormBR
          {...props}
          subdocumentField={subdocumentField}
          countryCode={countryCode}
        />
      ) : (
        // Company mode (CNPJ/NIPC/EIN) - dynamic by country
        <SimpleEntityCompanyFormBR
          {...props}
          subdocumentField={subdocumentField}
          countryCode={countryCode}
        />
      )}
      {/* ENTITY TYPE FORMS */}

      {/* NOTE */}
      {showNote ? (
        <Row>
          <Col span={24}>
            <SimpleInput name="note" style={{ width: '100%' }} />
          </Col>
        </Row>
      ) : null}
      {/* NOTE */}

      <Divider titlePlacement="end" plain />

      {/* ADDRESS FORM */}
      {showAddressForm && (
        <SimpleAddressForm
          {...props}
          subdocumentField="address"
          showNeighborhood={true}
          parentCountryCode={countryCode}
        />
      )}
      {/* ADDRESS FORM */}
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default SimpleEntityForm;

// *******************************************************************************
// HELPERS
// *******************************************************************************
